import { useGetOidcProviders } from './useGetOidcProviders';
import { OidcIdentityProviderDto } from '../../../../api-client';
import { useGetLoginConfig } from '../useGetLoginConfig';
import { QueryObserverResult, RefetchOptions, RefetchQueryFilters } from 'react-query';

type UseOidcProvidersQueries = () => {
  oidcProviders?: OidcIdentityProviderDto[],
  primaryConnectionId: string | undefined,
  isLoading: boolean,
  fetchError: unknown,
  refetchOidcProviders: <TPageData>(options?: ((RefetchOptions & RefetchQueryFilters<TPageData>) | undefined)) => Promise<QueryObserverResult<OidcIdentityProviderDto[], unknown>>,
};

export const useOidcProvidersQueries: UseOidcProvidersQueries = () => {

  const {
    data: oidcProviders,
    isFetching: isLoading,
    error: fetchError,
    refetch: refetchIdentityProviders,
  } = useGetOidcProviders(() => 0);

  const {
    data: loginConfig,
    isFetching: isFetchingConfig,
    error: loginConfigError,
  } = useGetLoginConfig();

  return {
    oidcProviders,
    primaryConnectionId: loginConfig?.primaryConnectionId,
    isLoading: isLoading || isFetchingConfig,
    fetchError: fetchError || loginConfigError,
    refetchOidcProviders: refetchIdentityProviders,
  };
};
